/* src/app/modules_v2/contacts/components/contact-form/contact-form.component.css */
.nav-pills .nav-link {
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
}
.nav-link.active {
  background-color: var(--cf-brand-dark);
  color: white;
  transition: all 0.2s ease-in-out;
  border-radius: 0.25rem;
}
.nav-link:not(.disabled):hover {
  background-color: var(--cf-brand-dark);
  color: white;
  transform: scale(1.02);
  cursor: pointer;
}
.table-title {
  margin-bottom: 1rem;
  padding: 0.5rem 0;
  border-bottom: 2px solid var(--cf-brand-dark);
}
.table-title h2 {
  margin: 0;
  font-size: 1.6rem;
  color: var(--cf-brand-dark);
  font-weight: 600;
}
.table-title .subtitle {
  margin: 0.2rem 0 0 0;
  font-size: 0.95rem;
  color: #6c757d;
}
/*# sourceMappingURL=contact-form.component.css.map */
